import pusher from '../pusher'
import { accommodationDestinationButtonMapper } from '../mappers/promotion-image/accommodation-destination-button-mapper'

export function listenButtonEvents (event) {
  event.on('clickButton', (data) => {
    const mappedData = accommodationDestinationButtonMapper(data)
    pusher.pushDataObject(mappedData)
  })
}
